import script from "./PlatMapPage.vue?vue&type=script&setup=true&lang=ts"
export * from "./PlatMapPage.vue?vue&type=script&setup=true&lang=ts"

import "./PlatMapPage.vue?vue&type=style&index=0&id=54118a8b&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-54118a8b"]])

export default __exports__